import { render, staticRenderFns } from "./headers-default.vue?vue&type=template&id=1bbf3cc6&scoped=true"
import script from "./headers-default.vue?vue&type=script&lang=js"
export * from "./headers-default.vue?vue&type=script&lang=js"
import style0 from "./headers-default.vue?vue&type=style&index=0&id=1bbf3cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf3cc6",
  null
  
)

export default component.exports